<template>
  <div class="hello">
    <h1>校運會報名</h1>
    <login-form v-if="!info" @login="loginSuccess"/>
    <application-form v-if="info" :info="info"/>
  </div>
</template>

<script>
  import LoginForm from './LoginForm';
  import ApplicationForm from './ApplicationForm';

  export default {
    name: 'hello',
    components: {
      LoginForm,
      ApplicationForm,
    },
    data() {
      return {
        info: null,
      };
    },
    methods: {
      loginSuccess(info) {
        this.info = info;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-size: 28px;
    font-weight: normal;
    text-align: center;
    margin-bottom: 36px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue